module.exports = {
  path: true,
  pathSyntax: true
};